export const tenantID = "fe51472c-6660-4ae5-995a-ac0f14ef2b07";
export const URL_STORE_APP =
  "https://apps.apple.com/mx/app/centro-operativo-del-gerente/id1672676029";
export const URL_STORE_ANDROID =
  "https://play.google.com/store/apps/details?id=com.alsea.appmanager";

export const API_GRAPH =
  "https://graph.microsoft.com/v1.0/me?$select=employeeID,displayName,givenName,jobTitle,mail,surname,companyName,onPremisesExtensionAttributes,lastPasswordChangeDateTime,accountEnabled";

export const REVOKE_URL = "https://graph.microsoft.com/v1.0/me/revokeSignInSessions";

export const VERSION_APP = "11.4.0";
export const BUILD_NUMBER = "153";

export const POLITICAS_PRIVACIDAD =
  "https://dev.centro.operaciones.alsea.net/Politicas_de_privacidad";

export const ALSE_PAGE = "https://alsea.net/home";

export const SITE_KEY = "6LflvTYoAAAAAMZWXgWk3ldmopRVDIuRlGRPpcWj";

export const SECRET_KEY = "6LflvTYoAAAAADfBvzPE8UTVbXBZU2WdPR5qFIWC";

export const DEV_OLD_AUTH_CONSOLE =
  "https://htwcnqlh13.execute-api.us-east-1.amazonaws.com/dev/home/";
export const DEV_NEW_AUTH_CONSOLE =
  "https://ch1q6ibky0.execute-api.us-east-1.amazonaws.com/v1/home/";
export const DEV_FRECUENCIAS_AUTH_CONSOLE =
  "https://x8yj4l5xri.execute-api.us-east-1.amazonaws.com/dev";
export const DEV_RECLASIFICACION_AUTH_CONSOLE =
  "https://ch1q6ibky0.execute-api.us-east-1.amazonaws.com/v1/home/";
export const PROD_OLD_AUTH_CONSOLE = "https://api.centro.operaciones.alsea.net/v1/";
export const PROD_NEW_AUTH_CONSOLE = "https://auffj3jfw9.execute-api.us-east-1.amazonaws.com/v1/";
export const PROD_FRECUENCIAS_AUTH_CONSOLE =
  "https://7to4qh3896.execute-api.us-east-1.amazonaws.com/prod";
export const PROD_RECLASIFICACION_AUTH_CONSOLE =
  "https://vnnzq3me97.execute-api.us-east-1.amazonaws.com/prod";

export const DEV_URL_DOMAIN_AUTH_FRECUENCIAS =
  "https://dev-api-gerentes.auth.us-east-1.amazoncognito.com/oauth2/token?grant_type=client_credentials";

export const DEV_CLIENT_ID_AUTH_FRECUENCIAS =
  "MWdxbjlxNGkyc29uMjdkZTRyZGJrdnRpcjY6aHFjdWNwOGRzZmZ1M2sxbmYydnNoc2w1bG5uZHVvZGRtdDhtb2hsdmtwc3FncnNuc3Ux";

export const PROD_URL_DOMAIN_AUTH_FRECUENCIAS =
  "https://prod-api-gerentes.auth.us-east-1.amazoncognito.com/oauth2/token?grant_type=client_credentials";

export const PROD_CLIENT_ID_AUTH_FRECUENCIAS =
  "M211dmwzMDZrMDY5cjk1b2szaGVvNW1laWs6MWdpMWE2YWhhODYzdXFtcnQ1Z3V1ajQxdDEydW9lZGNzbjlvY3VqdWhxcTVvaHZmY2hicA==";

export const PROD_NEW_AUTH_CONSOLE_FULL =
  "https://auffj3jfw9.execute-api.us-east-1.amazonaws.com/v1/home/";

export const ENVIROMENT = "dev";
